import { Box, Button, Card, CardActions, CardContent, Chip, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useMediaQuery } from '@mui/material'
import { Container } from '@mui/system'
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import './checkout.css'
import { Image } from 'cloudinary-react'
import { useGetOrderQuery, useUpdateOrderMutation } from '../../features/fullApi'
import { useTheme } from '@mui/material/styles';
import Error403 from '../ErrorPages/Error403'
import ClipLoader from 'react-spinners/ClipLoader'
import { toast } from 'react-hot-toast'
import ReactToPrint from 'react-to-print';
import PrintIcon from '@mui/icons-material/Print';
import moment from 'moment'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'


const OrderContainer = styled.div`
  min-height:100vh, 
  margin-top:122px, 
  font-family: Arial !important
`;

const OrderDetails = () => {
    const params = useParams()
    const user = JSON.parse(localStorage.getItem('user'))
    const navigate = useNavigate()
    window.scrollTo(0, 0);
    const {data, error, isLoading} = useGetOrderQuery(params.id);
    const [orderStatus, setOrderStatus] = useState("")


    const [addressData, setAddressData] = useState({})

    console.log("address data", addressData)
    console.log("DATA IS", data)
    useEffect(() => {
      console.log("CALLED USEFFECT")
        const add = axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/addresses/findOne/${data?.addressId}`)
        .then(res => setAddressData(res.data)).catch(err => console.log("err",err))
    }, [isLoading])

    useEffect(() => {
        getProductsNames()
        setOrderStatus(data?.status)
    }, [data])


    const componentRef = useRef();
    const [updateOrder] = useUpdateOrderMutation()

    const setToReady = (newStatus) => {
      updateOrder({_id: data._id, status: newStatus}, {id: data._id},{ 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          setOrderStatus(newStatus)
          toast.success(`Order status updated to ${newStatus}`)
          console.log("Res is", res);
        })
        .catch((e) => {
          console.log("e is", e)
        })
    }

    const [productsNames, setProductsNames] = useState([])
    const [productsImages, setProductsImages] = useState([])
    const [productsPrices, setProductsPrices] = useState([])

    const theme = useTheme()
 
    const isXs= useMediaQuery(theme.breakpoints.down('xs'));
    const isSm= useMediaQuery(theme.breakpoints.down('sm'));
    const isMd= useMediaQuery(theme.breakpoints.down('md'));
    const isLg= useMediaQuery(theme.breakpoints.down('lg'));
    const isXl= useMediaQuery(theme.breakpoints.down('xl'));
    
    const dispatch = useDispatch()

    const [finished, setFinished] = useState(false)

    const getProductsNames = async () => {
      data?.products?.map(async (product) => {
        const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/allItems/find/${product._id}`)
        .then(res => {
          productsNames.push(res.data.title)
          productsImages.push(res.data.img)
          productsPrices.push(res.data.price)
          setProductsNames([...productsNames])
          setProductsImages([...productsImages])
          setProductsPrices([...productsPrices])
        }).catch(err => {
          console.log("err is", err);
        })
      })
      setFinished(true)
    }



    const renderMobileOrderDetails = () => (
      <div style={{paddingBottom: '20px'}}>
        <div style={{fontSize: '14px'}}>
            <Container maxWidth="lg">
              {user.isAdmin && <Button variant="contained" color="secondary" style={{width: "140px", fontSize: '12px', marginTop: '20px'}} onClick={() => navigate(-1)}>Back to orders</Button>}
              <h2>Details for order:</h2>
              <h2>{data?._id}</h2>
              <Card sx={{display:'flex', justifyContent:'space-between', width:'100%', height:'100%'}}>
                <div style={{width:'300px'}}>
                  <CardContent>
                    <h3>Delivery address:</h3>
                    <Chip label="Phisical person" variant="contained" color="primary" />
                    <p>Name: {addressData?.name}</p>
                    <p>Surname: {addressData?.surname}</p>
                    <p>Country: {addressData?.country}</p>
                    <p>Region: {addressData?.state}</p>
                    <p>City: {addressData?.city}</p>
                    <p>Street: {addressData?.street}</p>
                    <p>Zipcode: {addressData?.zipcode}</p>
                  </CardContent>
                </div>
              </Card>

              <Card sx={{display:'flex', justifyContent:'space-between', width:'100%', height:'100%'}}>
                <div style={{width:'300px'}}>
                  <CardContent>
                    <h3>Products:</h3>
                    <Grid container justify="center" spacing={10}>
                      {data?.products?.map((prod, index) => (
                            <Grid item>
                              <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                                <Image cloudName="deqqgmfxk"  publicId={productsImages[index]} style={{width: '100px', height: '100px', objectFit:'cover', objectPosition:'center', marginRight:'20px'}}/>
                                <div>
                                  <p style={{marginRight: '20px'}}>Product: {productsNames[index]}</p>
                                  <p style={{marginRight: '20px'}}>Price: {productsPrices[index]}$</p>
                                  <p>Quantity: {prod?.quantity}</p>
                                </div>
                              </div>
                            </Grid>
                      ))}
                    </Grid>
                    <Box sx={{marginTop: '50px'}}>
                      <h3>Amount and Status: </h3>
                      <p>Order amount: {data?.amount}$</p>
                      <Chip label={orderStatus} variant="outlined" color="primary" />
                    </Box>
                  </CardContent>
                </div>
              </Card>
            </Container>
        </div>
      </div>
  )


      const renderTabletOrderDetails = () => (
        <div style={{padding: '40px'}}>
          <div style={{textAlign: 'center'}}>
            <Button variant="contained" style={{width: "300px", fontSize: '16px', textAlign: 'center'}} onClick={() => navigate(-1)}>Back to user orders</Button>
          </div>
          <div style={{fontSize: '16px !important'}}>
              <h1 style={{textAlign:"center", padding: '10px'}}>OrderNo: {data?._id}</h1>
              <Container maxWidth="lg">
                <Box className="cont">
                    <h2>Name: {addressData?.name}</h2>
                    <h2>Surname: {addressData?.surname}</h2>
                </Box>
                <Box className="cont">
                    <h2>Address:</h2>
                    <p>Country: {addressData?.country}</p>
                    <p>Region: {addressData?.region}</p>
                    <p>City: {addressData?.city}</p>
                    <p>Street: {addressData?.street}</p>
                    <p>Zipcode: {addressData?.zipcode}</p>
                </Box>
                <Box className="cont">
                  <h2>Products:</h2>
                  <Grid container justify="center" spacing={10}>
                    {data?.products?.map((prod, index) => (
                          <Grid item>
                          <p style={{marginRight: '20px'}}>{productsNames[index]} x {prod?.quantity}</p>
                            <Image cloudName="deqqgmfxk"  publicId={productsImages[index]} style={{width: '200px', height: '200px', objectFit:'cover', objectPosition:'center'}}/>
                          </Grid>
                    ))}
                  </Grid>
                </Box>
                <Box className="cont">
                  <h2>Amount and Status: </h2>
                  <p>Order amount: {data?.amount}$</p>
                  <p>Order status: {data?.status}</p>
                </Box>
              </Container>
          </div>
        </div>
    )

   

  
    const renderDesktopOrderDetails = () => (
    (isLoading) ? 
    (<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <ClipLoader
      color="#93032E"
      loading={isLoading}
      size={150}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  </div>)  : ( 
      <div className="order" style={{minHeight:'100vh', marginTop:'122px', fontFamily:"Arial !important"}}>
      <OrderContainer ref={componentRef}>
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom:'40px'}}>
        <Typography variant="h5" style={{marginRight:'10px'}}>Order Number</Typography>
        <Typography color="primary" variant="h5" style={{fontWeight:'bold'}}>#{data?._id}</Typography>
      </div>

      <div style={{width:'1200px', margin:'0 auto', display:'flex', justifyContent:'space-between'}}>
            <div style={{width:'700px', display:'flex', flexDirection:'column'}}>
            <TableContainer component={Paper} style={{marginBottom:'40px'}}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{fontWeight:'bold', fontSize:'17px'}}>Items Summary</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell>Total Price</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                          {data?.products?.map((prod, index) => (
                          <TableRow
                            key={productsNames[index]}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell>{productsNames[index]}</TableCell>
                            <TableCell>{prod?.quantity}</TableCell>
                            <TableCell>${productsPrices[index]}</TableCell>
                            <TableCell>${productsPrices[index] * prod.quantity}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
            </TableContainer>
            <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableBody>
                        <TableRow>
                            <TableCell variant="head" style={{fontWeight:'bold', fontSize:'17px'}}>Customer And Order Details</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell variant="head" style={{fontWeight:'bold'}}>Customer Name:</TableCell>
                            <TableCell style={{textAlign:'right'}}>{addressData?.surname} {addressData?.name}</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell variant="head" style={{fontWeight:'bold'}}>Phone Number:</TableCell>
                            <TableCell style={{textAlign:'right'}}>+40000000000</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell variant="head" style={{fontWeight:'bold'}}>Type:</TableCell>
                            <TableCell style={{textAlign:'right', fontSize:'17px'}}>Delivery</TableCell>
                          </TableRow>
                          <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell variant="head" style={{fontWeight:'bold'}}>Note:</TableCell>
                            <TableCell style={{textAlign:'right'}}>N/A</TableCell>
                          </TableRow>
                      </TableBody>
                    </Table>
            </TableContainer>
           {user.isAdmin &&
                       <div style={{display:'flex', marginTop:'40px', justifyContent:'space-between', alignItems:'center'}}>
                       <div>
                       {orderStatus === "pending" && (
                         <Button sx={{width:'150px'}} variant="outlined" onClick={() => setToReady("ready")}>Set to Ready</Button>
                       )}
                       {orderStatus === "ready" && (
                         <Button sx={{width:'150px'}} variant="outlined" onClick={() => setToReady("shipped")}>Set to Shipped</Button>
                       )}
                       {orderStatus === "shipped" && (
                         <Button sx={{width:'150px'}} variant="outlined" onClick={() => setToReady("fulfilled")}>Set to Fulfilled</Button>
                       )}   
                       </div>
                     </div>
              }

            </div>

            <div  style={{width:'400px', display:'flex', flexDirection:'column'}}>
              <Card sx={{ maxWidth: 450}} style={{marginBottom:'40px'}}>
                  <CardContent><Typography style={{fontWeight:'bold'}}>Delivery Address</Typography></CardContent>
                  <CardContent style={{display:'flex', justifyContent:'space-between'}}>
                    <div>
                      <Typography style={{fontWeight:'bold'}}>Country:</Typography>
                      <Typography style={{fontWeight:'bold'}}>Region:</Typography>
                      <Typography style={{fontWeight:'bold'}}>City:</Typography>
                      <Typography style={{fontWeight:'bold'}}>Street:</Typography>
                      <Typography style={{fontWeight:'bold'}}>Zipcode:</Typography>
                    </div>
                    <div style={{textAlign:'right'}}>
                      <Typography>{addressData?.country}</Typography>
                      <Typography>{addressData?.state}</Typography>
                      <Typography>{addressData?.city}</Typography>
                      <Typography>{addressData?.street}</Typography>
                      <Typography>{addressData?.zipcode}</Typography>
                    </div>
                  </CardContent>
                </Card>
                <Card sx={{maxWidth: 450, marginBottom:'40px', border:'1px solid #93032E'}} >
                  <CardContent sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <Typography style={{fontWeight:'bold', fontSize:'17px'}}>Total</Typography>
                    <Typography>${data?.amount}</Typography>
                  </CardContent>
                </Card>
                <Card sx={{ maxWidth: 450 }} style={{marginBottom:'40px'}}>    
                  <CardContent style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <div>
                      <Typography style={{fontWeight:'bold', fontSize:'17px'}}>Order Summary</Typography>
                    </div>
                    <div style={{textAlign:'right'}}>
                    <Chip label={orderStatus} variant="outlined" color="primary" />
                    </div>
                  </CardContent>
                  <CardContent style={{display:'flex', justifyContent:'space-between'}}>
                    <div>
                      <Typography style={{fontWeight:'bold'}}>Order Created:</Typography>
                      <Typography style={{fontWeight:'bold'}}>Subtotal:</Typography>
                      <Typography style={{fontWeight:'bold'}}>Delivery Fee:</Typography>
                    </div>
                    <div style={{textAlign:'right'}}>
                      <Typography>{moment(data?.createdAt).format("llll")}</Typography>
                      <Typography>${data?.amount}</Typography>
                      <Typography>$10</Typography>
                    </div>
                  </CardContent>
                </Card>
            </div>
      </div>
      </OrderContainer>
      <div style={{width:'1200px', margin:'20px auto', display:'flex', justifyContent:'space-between'}}>
        {/* <ReactToPdf targetRef={componentRef.current} filename={data._id}>
              {({toPdf}) => (
                    <Button onClick={toPdf} variant="outlined" startIcon={<FileDownloadIcon />} style={{width:'150px'}}>Invoice</Button>
                )}
              </ReactToPdf> */}
              
              <div>
              <ReactToPrint
                trigger={() => <Button style={{width:'150px'}} startIcon={<PrintIcon />}  variant="contained">Invoice</Button>}
                content={() => componentRef.current}
              />
            </div>
      </div>

    </div>))



    return (
      <div>
        {!error ?
          (
            (isXs) ?  renderMobileOrderDetails() : 
            (isSm) ? renderMobileOrderDetails() :
            (isMd) ? renderTabletOrderDetails() :
            renderDesktopOrderDetails()
          ) : (
            <Error403></Error403>
          )
        }
      </div>
    );
}

export default OrderDetails